import * as React from 'react';

/**
 * Создает элемент, который будет рендериться в компоненте ActionAfterViewObserver
 * Поддерживает работу с wrapper (html-тег) либо без него
 * */
export var createChild = function createChild(props, ref) {
  var _props$wrapper = props.wrapper,
      wrapper = _props$wrapper === void 0 ? 'div' : _props$wrapper,
      wrapperClass = props.wrapperClass,
      children = props.children;

  if (wrapper) {
    return /*#__PURE__*/React.createElement(wrapper, {
      ref: ref,
      className: wrapperClass
    }, children);
  }

  return /*#__PURE__*/React.cloneElement(children, {
    ref: ref
  });
};